module.exports = __webpack_public_path__ + "img/client11.145e8ff3.png";